import { trackEvent } from "./track";

export default function documentMailer() {
    const triggers = document.querySelectorAll(".email-link, .email-link-pdf, .callout-email-link, .sdm-questionnaire-results__nav-link");
    let modal;
    if (document.getElementById("sdm-email-doc-modal")) {
        modal = document.getElementById("sdm-email-doc-modal");
    } else {
        modal = document.getElementById("email-doc-modal");
    }

    for (let index = 0; index < triggers.length; index++) {
        const trigger = triggers[index];
        trigger.addEventListener("click", () => {
            const data = trigger.dataset;
            const title = data.bsTitle;
            const document = data.bsDocument;
            const jobCode = data.jobCode;
            const lastUpdate = data.lastUpdate;
            const indication = data.indication;
            let template = data.bsTemplate;

            const form = modal.querySelector("form");
            form.querySelector("[name='title']").value = title;
            form.querySelector("[name='jobCode']").value = jobCode;
            form.querySelector("[name='lastUpdate']").value = lastUpdate;
            form.querySelector("[name='indication']").value = indication;
            if (form.querySelector("[name='document']") !== null) {
                form.querySelector("[name='document']").value = document;
            }
            if (form.querySelector("[name='template']") !== null) {
                form.querySelector("[name='template']").value = template;
            }
            trackEvent({
                ModalDataNameEmailPDF: title
            });
        });
    }
}
